export default __webpack_public_path__ + "static/media/dashboard-banner.637df584.svg";